<template>
    <div class="sup-bady">
        <BannerComp class="banner-box" :product_video="product_video"></BannerComp>
        <EngineIntroduceComp class="engine-introduce-box"></EngineIntroduceComp>
        <EngineFeatureComp class="engine-feature-box"></EngineFeatureComp>
        <PerformanceComp class="performance-box"></PerformanceComp>
        <EcologicalPartnerComp class="ecological-partner-box"></EcologicalPartnerComp>
        <!-- <PictureWallComp
            class="picture-wall-box"
            v-if="swiper_1_list.length || swiper_2_list.length"
            :swiper_1_list="swiper_1_list"
            :swiper_2_list="swiper_2_list"></PictureWallComp> -->
        <!-- <EcologicalCooperationComp class="ecological-cooperation-box"></EcologicalCooperationComp> -->
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import { photoWallList, productVideo } from '@/service/interface';
import BannerComp from '@/components/Home/BannerComp.vue';
import EngineIntroduceComp from '@/components/Home/EngineIntroduceComp.vue';
import EngineFeatureComp from '@/components/Home/EngineFeatureComp.vue';
import EcologicalPartnerComp from '@/components/Home/EcologicalPartnerComp.vue';
import PerformanceComp from '@/components/Home/PerformanceComp.vue';
// import PictureWallComp from '@/components/Home/PictureWallComp.vue';
// import EcologicalCooperationComp from '@/components/Home/EcologicalCooperationComp.vue';

const { proxy } = getCurrentInstance();

const swiper_1_list = ref([]);
const swiper_2_list = ref([]);
const product_video = ref({ title: '', path: '' }); //产品视频数据

onMounted(() => {
    service_get_data();
});

// MARK Service 获取数据
const service_get_data = () => {
    proxy.$showLoading();
    let promiseArray = [productVideo(), photoWallList()];
    Promise.all(promiseArray).then((response) => {
        proxy.$hideLoading();
        if (response[0].isSuccess) {
            // 查询产品视频
            let productVideo_response = response[0].data;
            product_video.value.title = productVideo_response.name;
            product_video.value.path = productVideo_response.videoPath;
            const videoElement = document.getElementById('id-product-video');
            if (videoElement) {
                videoElement.load();
            }
        }
        if (response[1].isSuccess) {
            // 查询照片墙列表
            let photoWallList_response = response[1].data;
            swiper_1_list.value = [];
            swiper_2_list.value = [];
            photoWallList_response.rowFirst.forEach((e) => {
                swiper_1_list.value.push({
                    name: e.name,
                    fileName: e.name,
                    url: window.downloadBaseUrl + '/' + e.photoPath,
                });
            });
            photoWallList_response.rowSecond.forEach((e) => {
                swiper_2_list.value.push({
                    name: e.name,
                    fileName: e.name,
                    url: window.downloadBaseUrl + '/' + e.photoPath,
                });
            });
        }
    });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--color-main-light-bg);

    .banner-box {
        width: 100%;
        height: 500px;
    }

    .engine-introduce-box {
        width: 100%;
        margin-top: 72px;
    }

    .engine-feature-box {
        width: 100%;
        margin-top: 97px;
    }

    .performance-box {
        width: 100%;
        margin-top: 100px;
    }

    .ecological-partner-box {
        width: 100%;
        margin-top: 100px;
        margin-bottom: 100px;
    }



    // .ecological-cooperation-box {
    //     margin-top: 70px;
    // }

    // .picture-wall-box {
    //     margin-top: 120px;
    // }
}
</style>
